<template>
    <v-card>
        <v-card-title class="pb-0">
            <v-btn color="info" small outlined @click="listar">
                <v-icon>refresh</v-icon> Refrescar
            </v-btn>
            <v-spacer></v-spacer>
            <span class="text-caption grey--text text--darken-1">Últimos 100 movimientos de la cuenta</span>
        </v-card-title>
        <v-card-text>
            <v-data-table
                dense class="elevation-1"
                :headers="columnas" :items="accesos" :loading="cargando"
                item-key="acceso_id" hide-default-footer disable-pagination
                fixed-header height="60vh"
            >
                <template v-slot:item="{ item }">
                    <tr>
                        <td class="text-no-wrap">{{ item.fecha | fechaESPHora }}</td>
                        <td>
                            <v-chip x-small label text-color="white" :color="estilo(item.resultado).color">
                                <v-icon x-small left>{{ estilo(item.resultado).icono }}</v-icon>
                                {{ estilo(item.resultado).texto }}
                            </v-chip>
                        </td>
                        <td>{{ item.detalle || '—' }}</td>
                        <td class="text-no-wrap">{{ item.ip || '—' }}</td>
                        <td class="text-caption" :title="item.agente">{{ navegador(item.agente) }}</td>
                    </tr>
                </template>
                <template v-slot:no-data>
                    <v-alert dense type="warning" outlined class="text-center mt-3">
                        Sin movimientos registrados todavía.
                    </v-alert>
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>
</template>

<script>
const ESTILOS = {
    exitoso: {texto: "Ingreso correcto", color: "success", icono: "login"},
    fallido: {texto: "Contraseña incorrecta", color: "error", icono: "block"},
    codigo_fallido: {texto: "Código incorrecto", color: "error", icono: "pin"},
    bloqueado: {texto: "Ingreso bloqueado", color: "warning", icono: "lock"},
    password: {texto: "Contraseña", color: "info", icono: "vpn_key"},
    seguridad: {texto: "Cambio de seguridad", color: "primary", icono: "security"},
};

export default {
    name: "ParticipantesAdministradoresRegistroAccesos",
    props: {
        getParams: {type: Object, required: true},
    },
    data() {
        return {
            cargando: false,
            accesos: [],
            columnas: [
                {text: 'Fecha y hora', value: 'fecha', sortable: false},
                {text: 'Evento', value: 'resultado', sortable: false},
                {text: 'Detalle', value: 'detalle', sortable: false},
                {text: 'IP', value: 'ip', sortable: false},
                {text: 'Navegador', value: 'agente', sortable: false},
            ],
        }
    },
    methods: {
        estilo(resultado) {
            return ESTILOS[resultado] || {texto: resultado, color: "grey", icono: "info"};
        },
        navegador(agente) {
            if (!agente) return "—";

            const navegador = /Edg\//.test(agente) ? "Edge"
                : /OPR\//.test(agente) ? "Opera"
                : /Chrome\//.test(agente) ? "Chrome"
                : /Firefox\//.test(agente) ? "Firefox"
                : /Safari\//.test(agente) ? "Safari" : "Otro";

            const sistema = /Windows/.test(agente) ? "Windows"
                : /Android/.test(agente) ? "Android"
                : /iPhone|iPad/.test(agente) ? "iOS"
                : /Mac OS/.test(agente) ? "macOS"
                : /Linux/.test(agente) ? "Linux" : "";

            return sistema ? `${navegador} · ${sistema}` : navegador;
        },
        listar() {
            this.cargando = true;
            const params = {persona_id: this.getParams.persona_id};

            window.axios.get('/cuentas/accesos', {params}).then(response => {
                if (response.data.success) {
                    this.accesos = response.data.data;
                } else {
                    this.$toast.error(response.data.message);
                }
            })
                .catch(() => this.$toast.error("No se pudo consultar el registro de accesos."))
                .finally(() => {
                    this.cargando = false;
                });
        },
    },
    created() {
        this.listar();
    },
}
</script>
